/**
 * Payment Data Validation Utilities
 * Input validation to prevent runtime errors
 */

import logger from 'ws-scripts/modules/logger';

/**
 * Check if value is a valid payment object
 * @param {*} obj - Value to check
 * @returns {boolean}
 */
export const isValidPaymentObject = (obj) => {
	return (
		obj !== null &&
		obj !== undefined &&
		typeof obj === 'object' &&
		!Array.isArray(obj)
	);
};

/**
 * Validate payment array structure
 * @param {Array} paymentArray - Array to validate
 * @returns {{ valid: boolean, error?: string, invalidItems?: Array }}
 */
export const validatePaymentArray = (paymentArray) => {
	if (!Array.isArray(paymentArray)) {
		return { valid: false, error: 'Payment data must be an array' };
	}

	if (paymentArray.length === 0) {
		return { valid: false, error: 'Payment array is empty' };
	}

	const invalidItems = paymentArray.filter(
		(item) => !isValidPaymentObject(item)
	);

	if (invalidItems.length > 0) {
		logger.warn('WS-TRACK-MY-OFFER: Found invalid payment objects', {
			invalidCount: invalidItems.length,
			totalCount: paymentArray.length
		});
		// Continue processing valid items instead of failing completely
	}

	return { valid: true };
};

/**
 * Validate and normalize payment array (handles nested arrays)
 * @param {Array|Array<Array>} paymentArray - Raw payment array from event
 * @returns {{ valid: boolean, normalized?: Array, error?: string }}
 */
export const validateAndNormalizePaymentArray = (paymentArray) => {
	// Normalize nested array: [[payment1, payment2]] -> [payment1, payment2]
	const normalized = Array.isArray(paymentArray?.[0])
		? paymentArray[0]
		: paymentArray;

	const validation = validatePaymentArray(normalized);

	if (!validation.valid) {
		return { valid: false, error: validation.error };
	}

	return { valid: true, normalized };
};
